import { SvgIcon } from '@mui/material';

export function Offer() {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5999 22C10.3999 22.8 11.5999 22.8 12.3999 22L21.3999 13C21.7999 12.6 21.9999 12.1 21.9999 11.6V4C21.9999 2.9 21.0999 2 19.9999 2H12.3999C11.8999 2 11.3999 2.2 10.9999 2.6L1.9999 11.6C1.1999 12.4 1.1999 13.6 1.9999 14.4L9.5999 22ZM18.1999 7.70001C18.1999 8.80458 17.3045 9.70001 16.1999 9.70001C15.0953 9.70001 14.1999 8.80458 14.1999 7.70001C14.1999 6.59544 15.0953 5.70001 16.1999 5.70001C17.3045 5.70001 18.1999 6.59544 18.1999 7.70001Z"
        fill="#2F313F"
      />
    </SvgIcon>
  );
}
